import { EntityType } from '@frontend/common';
import { useAccountRepository } from '@frontend/repository';
import { SettingClient } from '@frontend/setting/api';
import { SettingKey } from '@frontend/setting/types';
import { useEffect, useState } from 'react';

import { PersonalQrCodeCardProps } from './personal-qr-code-card.component';

interface ViewProps {
    enabled: boolean;
    isLoading: boolean;
}

export const usePersonalQrCodeCard = (props: PersonalQrCodeCardProps): ViewProps => {
    const { currentAccount } = useAccountRepository();
    const [enabled, setEnabled] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        SettingClient.fetchSettings({ entity_type: EntityType.ACCOUNT, entity_id: currentAccount, key: SettingKey.ALLOW_PERSONAL_QR_ACCESS_CODE })
            .then((settings) => {
                if (settings.results.length > 0) {
                    const setting = settings.results[0];
                    setEnabled(!!setting.value);
                } else {
                    setEnabled(false);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setEnabled(false);
                setIsLoading(false);
            });
    }, [currentAccount]);

    return {
        enabled,
        isLoading
    };
};
